import { Component, OnInit,Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { TypeEvent } from '../../models/type-event';
import { TypeEventService } from '../../services/type-event.service';
import { ColorEventService } from '../../services/color-event.service';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-type-event',
  templateUrl: './type-event.component.html',
  styleUrls: ['./type-event.component.css']
})
export class TypeEventComponent implements OnInit {
  publicating = false;
  typeEvent: TypeEvent;
  typeEventes: any;
  @Input() TypeEventID;
  @Input() nameComponent;
  @Input() TypeEventes;
  errorMessage: string;
  colorselector: any;
  createTypeEvent = true;

  status=[
    {
      id:1,
      name:'Activo',
    },
    {
      id:0,
      name:'Inactivo',
    },
    {
      id:-6,
      name:'Eliminado',
    }
  ]

  constructor(public dialogRef: MdDialogRef<TypeEventComponent>,
    public colorEventService: ColorEventService, public typeEventService: TypeEventService, private dialog: MdDialog) { }

  ngOnInit() {
    this.colorEventService.getColorEvent()
    .subscribe(
      data => {
        this.colorselector = data;
      },
      error => {
        let err = error;
        this.errorMessage = <any>error;
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: this.errorMessage, alert: true, showIcon:true}});
      }
    );
    if (this.nameComponent === "Agregar"){
      this.createTypeEvent = true;
    } else {
      this.createTypeEvent = false;
    }
    this.typeEvent = new TypeEvent();

    if(this.TypeEventes.length > 0){
      //Load data user for ID
      this.typeEventes = this.TypeEventes;
      this.getTypeEvent(this.TypeEventID);
    } else {
      this.typeEvent = new TypeEvent();
      this.getTypeEvent(1);
    }
  }

  getTypeEvent(id){
    for(let i = 0; i < this.typeEventes.length; i++){
      if(id === this.typeEventes[i].id){
        this.typeEvent.id = this.typeEventes[i].id;
        this.typeEvent.name = this.typeEventes[i].name;
        this.typeEvent.color = this.typeEventes[i].color;
      }
    }
  }

  onTypeEvent(){
    if (this.createTypeEvent) {
      this.onPostTypeEvent();
    } else {
      this.onPutTypeEvent();
    }
  }

  onPutTypeEvent() {
    this.publicating = true;
    this.typeEventService.putTypeEvent(this.typeEvent)
      .subscribe(
        data => {
          this.typeEventes = data;
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = error;
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: this.errorMessage, alert: true, showIcon:true}});
        }
      );
  }

  onPostTypeEvent() {
    this.publicating = true;
    this.typeEventService.postTypeEvent(this.typeEvent)
      .subscribe(
        data => {
          this.typeEventes = data;
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = JSON.parse(error);
          let err2 = err;
          let txterrors = "";
          console.log(err);
            for( let element in err) {
              console.log(err2[element]);
                let err: any;
                let txterr: string = "";
                for(let err in err2[element]){
                  txterr = txterr+" "+err2[element][err];
                  console.log(err);
                }
                txterrors = txterrors+", "+txterr;
            };
          this.errorMessage = <any>error
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: txterrors, alert: true, showIcon:true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/type-event/type-event.component.ts